<mat-toolbar class="footer" *ngIf="work" [class.chat-mode]="chatMode">
  @if(!chatMode){
    @for (document of ancestors; track document.id + document.type) {
      <button 
          mat-raised-button class="primary goToButton"
          [hidden]="clientMode()"
          go-to-details
          [element]="document"
          mode="modal"
      >
        <span class="display-desktop">Ver {{ document.type | human }} Nº {{document.correlative_id}}</span>
        <span class="display-mobile"><i class="fa fa-eye"></i></span>
      </button>
    }
    <div class="expander"></div>
  }

  

  @if (work().user_id){
    @if (work().work?.action_buttons_type === 'next_statuses') {
      @if (!work().completed_at) {
        <button mat-raised-button class="warn margin-right-md" (click)="reject()" [hidden]="cannotReject">
          <div style="display: flex;">
            <span>Rechazar</span><span class="display-desktop">&nbsp;trabajo</span>
          </div>
        </button>

        <span class="margin-right-md">ó</span>

        <span> Mover a: </span>
        @if (work()?.next_statuses?.length <= 3) {
          <ng-container *ngFor="let status of work().next_statuses">
            <button
                mat-button
                class="primary margin"
                (click)="onSetStatus(status)"
                [hidden]="isReadOnly() || clientMode()"
                [disabled]="cannotComplete() || updating() "
                [ngStyle]="{backgroundColor: status.color}"
            >
              <span>{{status.name}}</span>
            </button>
          </ng-container>
        } @else if (work().next_statuses?.length > 3) {
          <button
              mat-raised-button
              class="primary"
              [matMenuTriggerFor]="menu"
              [hidden]="isReadOnly() || clientMode()"
              [disabled]="cannotComplete() || updating() "
              >
            @if(updating()){
              <mat-progress-spinner diameter="20" mode="indeterminate"></mat-progress-spinner>
            }@else{
              <i class="fa fa-pencil-alt"></i>
            }
            <span class="hide-mobile">{{work().document.status_id | status}}</span>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item
                    *ngFor="let status of work().next_statuses"
                    (click)="onSetStatus(status)"
                    [style.color]="status.color"
                    [disabled]="cannotComplete() || updating()"
            >
              {{status.name}}
            </button>
          </mat-menu>
        }
      } @else {
        <button mat-raised-button class="primary margin" disabled>
          <span>Trabajo finalizado</span>
        </button>
      }
    }
  
    @else if (work().work?.action_buttons_type === 'finish_decline') {
      @if (actionButtons()) {
        <ng-container *ngFor="let button of actionButtons()">
          <button mat-raised-button
                  class="primary margin"
                  (click)="complete(button.action)"
                  [disabled]="!button.enabled"
                  [hidden]="isReadOnly()"
                  >
            <span>{{button.label}}</span>
          </button>
        </ng-container>
      } @else {
        <button 
            mat-raised-button class="primary margin"
            [class.approve]="isRevisor()"
            (click)="complete()"
            [disabled]="cannotComplete()"
            [hidden]="clientMode()">
          <span *ngIf="work().completed_at">Trabajo finalizado</span>
          <div *ngIf="!work().completed_at && (!work().work || !work().work.require_revision || isRevisor())" style="display: flex;">
            <span *ngIf="work().work && work().work.sign_needed">Firmar y </span>
            {{isRevisor() ? 'Aprobar' : 'Finalizar'}}
            <span class="display-desktop">&nbsp;{{work().work?.name || 'Trabajo'}}</span>
          </div>
          <span *ngIf="work()?.work && !work().completed_at && work().work.require_revision && !work().revisor_id">Enviar para revisión</span>
          <span *ngIf="waitingRevision() && !isRevisor()">Esperando revisión</span>
        </button>
      }
  
      <button mat-raised-button class="warn margin" (click)="reject()" [hidden]="cannotReject">
        <div style="display: flex;">
          <span>Rechazar</span><span class="display-desktop">&nbsp;trabajo</span>
        </div>
      </button>
    }
  } @else {
    <button mat-raised-button class="primary magin" (click)="setUser()">
      <span>ASIGNAR USUARIO</span>
    </button>
  }

  
</mat-toolbar>
